import React from "react";
import Error from "../Components/error/Error";

const NotFound = () => {
	return <Error />;
};

export default NotFound;
